import React, { useState } from "react";
import "../css/register.css";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config";

if (typeof window !== "undefined") {
  require("react-toastify/dist/ReactToastify.css");
}

const Register = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const validate = () => {
    const newErrors = {};

    if (!firstname.trim()) newErrors.firstname = "First name is required";
    if (!lastname.trim()) newErrors.lastname = "Last name is required";
    if (!username.trim()) newErrors.username = "Username is required";

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      newErrors.email = "Enter a valid email";
    }

    if (!phone.trim()) {
      newErrors.phone = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(phone)) {
      newErrors.phone = "Enter valid 10-digit number";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Minimum 6 characters required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRegister = async () => {
    if (!validate()) return;

    try {
      const res = await axios.post(`${API_BASE_URL}/register`, {
        firstname,
        lastname,
        username,
        email,
        phone,
        password,
      });

      toast.success(res.data.message || "Registered successfully!");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Registration failed!"
      );
    }
  };

  const inputClass = (field) => (errors[field] ? "input-error" : "");

  return (
    <div className="register-container">
      <div className="register-box">
        <h2>Create Account</h2>

        <div className="form-field">
          <input
            type="text"
            placeholder=" "
            className={inputClass("firstname")}
            value={firstname}
            onChange={(e) => {
              setFirstname(e.target.value);
              setErrors({ ...errors, firstname: "" });
            }}
          />
          <label>First Name</label>
          {errors.firstname && (
            <span className="error-text">{errors.firstname}</span>
          )}
        </div>

        <div className="form-field">
          <input
            type="text"
            placeholder=" "
            className={inputClass("lastname")}
            value={lastname}
            onChange={(e) => {
              setLastname(e.target.value);
              setErrors({ ...errors, lastname: "" });
            }}
          />
          <label>Last Name</label>
          {errors.lastname && (
            <span className="error-text">{errors.lastname}</span>
          )}
        </div>

        <div className="form-field">
          <input
            type="text"
            placeholder=" "
            className={inputClass("username")}
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setErrors({ ...errors, username: "" });
            }}
          />
          <label>Username</label>
          {errors.username && (
            <span className="error-text">{errors.username}</span>
          )}
        </div>

        <div className="form-field">
          <input
            type="email"
            placeholder=" "
            className={inputClass("email")}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErrors({ ...errors, email: "" });
            }}
          />
          <label>Email</label>
          {errors.email && (
            <span className="error-text">{errors.email}</span>
          )}
        </div>

        <div className="form-field">
          <input
            type="text"
            placeholder=" "
            className={inputClass("phone")}
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
              setErrors({ ...errors, phone: "" });
            }}
          />
          <label>Mobile Number</label>
          {errors.phone && (
            <span className="error-text">{errors.phone}</span>
          )}
        </div>

        <div className="form-field password-field">
          <input
            type={showPassword ? "text" : "password"}
            placeholder=" "
            className={inputClass("password")}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setErrors({ ...errors, password: "" });
            }}
          />
          <label>Password</label>

          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "Hide" : "Show"}
          </span>

          {errors.password && (
            <span className="error-text">{errors.password}</span>
          )}
        </div>

        <button className="submit-btn full-width" onClick={handleRegister}>
          Create Account
        </button>

        <p className="signin-linkreg">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Register;
